import * as R from 'ramda';

export default function uniqueAssetTypeNameDirective(
  $q,
  assetDataService
) {
  return {
    restrict: 'A',
    require: '?ngModel',
    link,
  };

  function link(scope, el, attrs, ctrl) {
    const customerAssetTypeId = attrs.customerAssetTypeId || -1;

    ctrl.$asyncValidators.uniqueAssetTypeName = (modelValue) => {
      if (ctrl.$isEmpty(modelValue)) {
        // Consider empty model valid. This is probably the view's initial load.
        return $q.resolve();
      }

      const name = _getName(modelValue);

      if (!name) {
        // Nothing to check, move along... move along...
        return $q.resolve();
      }

      const def = $q.defer();

      // We have a name, so see if it exists
      assetDataService.checkCustomerAssetTypeExists(customerAssetTypeId, name).then((response) => {
        const isExists = response.data.result;
        if (!isExists) {
          def.resolve();
        } else {
          def.reject();
        }
      }).catch(() => def.reject());

      return def.promise;
    };
  }

  function _getName(modelValue) {
    switch (R.type(modelValue)) {
      case 'Object':
        return modelValue.name;
      default:
        // Assume modelValue is a string
        return modelValue;
    }
  }
}

export const name = 'uniqueAssetTypeName';

uniqueAssetTypeNameDirective.$inject = [
  '$q',
  'assetDataService'
];
